import type { LngLat, Route } from '../core/types';
import { activeVehicle, type Settings } from '../core/settings';
import { projectPointOntoLine } from '../core/geo';

// Driver report, 12 September 2026. Grade separation is not established:
// conservatively reject crossings of this short corridor as well as travel along it.
export const REPORTED_LOW_PASSAGE = {
  height: 2.5,
  start: [100.73177374504566, 14.238904463921289] as LngLat,
  end: [100.73188538462063, 14.239584639040535] as LngLat,
};

function applies(settings: Settings): boolean {
  return (activeVehicle(settings).height ?? 0) >= REPORTED_LOW_PASSAGE.height;
}

const corridorHits = new WeakMap<Route, boolean>();

export function reportedExclusions(settings: Settings): string[] {
  if (!applies(settings)) return [];
  const { start, end } = REPORTED_LOW_PASSAGE;
  return [0.25, 0.5, 0.75].map(t => `point(${start[0] + (end[0] - start[0]) * t} ${start[1] + (end[1] - start[1]) * t})`);
}

export function reportedRestrictionViolation(route: Route, settings: Settings): string | null {
  if (!applies(settings)) return null;
  const message = 'Route crosses a driver-reported 2.5 m clearance area near Wang Noi. Choose another route.';
  const cached = corridorHits.get(route);
  if (cached !== undefined) return cached ? message : null;
  const { start, end } = REPORTED_LOW_PASSAGE;
  const line = route.geometry.coordinates as LngLat[];
  // About 4 m between samples, including both user-specified endpoints. A small
  // tolerance covers map alignment; do not infer which stacked road is safe.
  for (let i = 0; i <= 20; i++) {
    const p: LngLat = [start[0] + (end[0] - start[0]) * i / 20, start[1] + (end[1] - start[1]) * i / 20];
    if ((projectPointOntoLine(p, line)?.distance ?? Infinity) <= 15) {
      corridorHits.set(route, true);
      return message;
    }
  }
  corridorHits.set(route, false);
  return null;
}
